import React from "react";
import { classNames } from "utils/ui";

const Summary = ({ lineItems, amountItems }) => {
  return (
    <div className="flex flex-column">
      <div className="dib dn-ns">
        <div className="">
          <dl className=" space-y-4">
            <dt className="f5 fw6 pb-4 mb-4 bb hairline-1 ttu ">Items</dt>
            {lineItems.map((row) => {
              return (
                <div
                  key={row.uuid}
                  className="pv1 pv2 grid grid-cols-3 gapa2 flex justify-between"
                >
                  <div className="flex flex-column items-start">
                    <div className="f5  black-90 pr-4">{row.description}</div>
                    {row.quantity > 0 && (
                      <div className="f5 mt0 col-span-2">{`Qty: ${row.quantity}`}</div>
                    )}
                  </div>
                  {row.amount && (
                    <div className="flex flex-column">
                      <div className="f5 mt0 col-span-2">{row.amount}</div>
                    </div>
                  )}
                </div>
              );
            })}
            <div className="bt ba hairline-1 pt3 mt-3">
              {amountItems.map((row) => {
                return (
                  <div
                    key={row.uuid}
                    className="pv1 pv2 grid grid-cols-3 gapa2 flex justify-between"
                  >
                    <div className="flex flex-column items-start">
                      <div className="f5  pr-4">{row.label}</div>
                    </div>
                    {row.amount && (
                      <div className="flex flex-column">
                        <div className="f5 mt0 col-span-2">{row.amount}</div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </dl>
        </div>
      </div>
      <div className="dn dib-ns overflow-x-auto">
        <div className="align-middle inline-block w-100">
          <div className="overflow-hidden">
            <table className="w-100 " cellSpacing="0">
              <thead>
                <tr>
                  <th scope="col" className="pv3 tl f6 ttu fw6">
                    Description
                  </th>
                  <th scope="col" className="ph2 pv3 f6 ttu fw6 tr">
                    Qty
                  </th>
                  <th scope="col" className="ph2 pv3 f6 ttu fw6 tr">
                    Unit Price
                  </th>
                  <th scope="col" className="ph2 pv3 f6 ttu fw6 tr">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white  pointer">
                {lineItems.map((row) => (
                  <tr key={row.uuid}>
                    <td
                      className={classNames(
                        row.amount ? "black-90 " : "",
                        "pv3 f5"
                      )}
                    >
                      {row.description}
                    </td>
                    <td className="ph2 pv3 f5 tr">{row.quantity}</td>
                    <td className="ph2 pv3 f5 tr">{row.unitAmount}</td>
                    <td className="ph2 pv3 f5 tr">{row.amount}</td>
                  </tr>
                ))}
              </tbody>
              <tbody className="bg-white">
                {amountItems.map((row) => (
                  <tr key={row.uuid}>
                    <td className="ph2 pv2 f5 black-90 tr" colSpan={3}>
                      {row.label}
                    </td>
                    <td className="ph2 pv2 f5 tr">{row.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
